  
<div class="row">
  <app-dashboard-menu></app-dashboard-menu>
  <!-- <div class="DashboardContentArea"> -->
      <!-- <div class="dashboardContentAreaLeft"> -->
       <div class="dashboardContentBox">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
               <div class="row">
                  <div class="col-12">
                      <div class="table-responsive">
                        <table datatable #dtElement  [dtOptions]="dtOptions" class="table width-100">
                            <!-- <table  class="table width-100"> -->
                          <thead>
                            <tr class="bg-primary text-white">
                              
                              <th>{{'trackingNo' | translate}}</th>                     
                              <th>{{'customer' | translate}}</th>
                              <th>{{'requiredname' | translate}}</th>
                              <th>{{'implementationType' | translate}}</th>
                              <th>{{'serviceStatus' | translate}}</th>
                              <th>{{'assignedTo' | translate}}</th>                          
                              <th>{{'lastAction' | translate}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <!-- [ngClass]="{'background-row-delay-color': order.isExceededDate === true && order.statusId !== requestStatusEnum.Cancelled && order.statusId !== requestStatusEnum.Completed && isCustomer === false && isCourt === false}" -->
                            <tr *ngFor="let order of ordersList">
                              <td><a class="main-color" routerLink="/order/orderServiceDetails/{{order.requestOrderDetailId}}">
                                {{order.trackingNo}}</a>
                              <br>                  
                              {{order.createdOn | customDate:"dd MMM, yyyy hh:mm a"}}                             
                              </td>
                              <td>{{order.customer}}</td>
                              <td>{{ order.requiredName }}</td>
                              <td>{{ order.implementationType }}</td>
                              <td>
                                
                                {{ order.status }}<br>
                                <span
                                  *ngIf="order.statusId === 2 && order.assignedTo !== null"
                                  style="color: mediumblue;">({{'assigned' | translate}})
                                </span>

                              </td>
                              <!-- <td>{{ order.assignedTo}} <br>  {{ order.assignedAuditUser}}</td> -->
                               <td>
                                <a class="main-color" routerLink="/user/userDetails/{{order.assignedUserId}}"
                                  href="javascript:(void)">
                                {{ order.assignedTo }}
                                 </a>
                                <br>  
                                 <a class="main-color" routerLink="/user/userDetails/{{order.assignedAuditUserId}}"
                                  href="javascript:(void)">
                                {{ order.assignedAuditUser}}
                                </a>
                                </td>
                             <td> 
                                  {{order.lastAction | customDate:"dd MMM, yyyy hh:mm a"}}                                  
                                   
                              </td>
                            

                            </tr>
                          </tbody>
                          <tbody *ngIf="ordersList?.length == 0">
                            <tr>
                              <td colspan="10" class="no-data-available">{{'noDataFound' | translate}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                   </div>
                </div>
            </div>
          </div>
        </div>
      </div>
         <div class="dashboardContentBox">
            <div class="dashboardContentBoxHeading">               
              {{'delay' | translate}}
            </div>
            <div class="dashboardContentBoxBody">
                
                <div style="display: block">
                    <canvas baseChart
                        [datasets]="barChartDataDelay"
                        [labels]="barChartLabelsDelay"
                        [options]="barChartOptions"
                        [colors]="barChartColorsDelay"          
                        [chartType]="barChartType"
                        (chartHover)="chartHovered($event)"                                                             
                        (chartClick)="chartClicked($event)"></canvas>

                </div>
            </div>
         </div>
      
      <!-- </div> -->
      
      <!-- <div class="dashboardContentAreaRight " style="grid-template-columns:100%;">       -->
   
     
  <!-- </div> -->
</div>              
